<template>
  	<div id="app">
		<app-header v-if="$route.path != '/sales/overview'"></app-header>
		<div id="wrapper" class="app-sidebar-right" v-if="$route.path != '/sales/overview'">
            <app-sidebar></app-sidebar>
            <router-view></router-view>
        </div>
        <div v-else>
            <fornt-header></fornt-header>
            <router-view></router-view>
        </div>
  	</div>
</template>

<script>
	import "@babel/polyfill";
    import Header from '@/components/partials/Header';    
    import FrontHeader from '@/components/partials/Front-Header';    
    import Footer from '@/components/partials/Footer';
    import Sidebar from '@/components/partials/Sidebar';
	import EventBus from '../../frontend/src/components/event-bus';
    import GoogleMap from './components/GoogleMap.vue'
	var contex;
	export default {
		components: {
            'app-header': Header,
            'fornt-header': FrontHeader,
            'app-footer': Footer,
            'app-sidebar': Sidebar,
            'gmap': GoogleMap,
        },
		name: 'App',
		data: () => ({
            showHeader: true,
        }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function() {
        },

        methods : {

        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            }
        }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue